// extracted by mini-css-extract-plugin
export default {"checkBoxWrap":"checkBoxWrap--eWXsI","checkBox":"checkBox--CPMFc"};